/**
 * @since 2023-04-15
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import BarActionsAnalysis from "components/Shared/BarActionsAnalysis";
import ButtonBlue from "components/Shared/ButtonBlue";
import Report from "components/Shared/Report";
import TextCopyright from "components/Shared/TextCopyright";
import TextError from "components/Shared/TextError";
import TextWait from "components/Shared/TextWait";
import {
  createPortfolioAnalysis,
  getStatusPortfolioAnalysis,
  loadPortfolioAnalysis,
  waitForPortfolioAnalysis,
} from "dataHandling/portfolio";
import { useEffect, useState } from "react";

const PanelAnalysis = ({
  email,
  portfolioId,
  portfolioName,
  onScoresClick,
  containsOnlyStrategies,
}) => {
  //region States

  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [analysisData, setAnalysisData] = useState({});

  //endregion

  //region Use Effects

  useEffect(() => {
    fetchData();
  }, [portfolioId, email]);

  //endregion

  //region Methods

  const fetchData = async () => {
    setIsLoading(true);
    let newStatus = await getStatusPortfolioAnalysis(email, portfolioId);
    if (newStatus === "WAITING") {
      setStatus(newStatus);
      newStatus = await waitForPortfolioAnalysis(email, portfolioId);
    }
    if (newStatus === "OK") {
      const newAnalysisData = await loadPortfolioAnalysis(email, portfolioId);
      setAnalysisData(newAnalysisData);
    }
    setStatus(newStatus);
    setIsLoading(false);
  };

  const handleCreateAnalysis = async () => {
    setStatus("WAITING");
    await createPortfolioAnalysis(email, portfolioId);
    fetchData();
  };

  //endregion

  return (
    <>
      {status === "WAITING" && <TextWait />}
      {status === "ERROR" && (
        <>
          <TextError error="Something went wrong, we are working on it. Please try again later." />
          <ButtonBlue
            label="CREATE ANALYSIS"
            alignment="left"
            onClick={handleCreateAnalysis}
          />
        </>
      )}
      {status === "NEW" && (
        <ButtonBlue
          label="CREATE ANALYSIS"
          alignment="left"
          onClick={handleCreateAnalysis}
        />
      )}
      {status === "OK" && (
        <>
          <Report
            email={email}
            moduleType={"PORTFOLIO"}
            moduleId={portfolioId}
            reportData={analysisData}
          />
          <br />
          <br />
          <BarActionsAnalysis
            email={email}
            moduleType={"PORTFOLIO"}
            moduleId={portfolioId}
            moduleName={portfolioName}
            showTrades={containsOnlyStrategies}
          />
          <br />
          <ButtonBlue label="SEE SCORES" onClick={onScoresClick} />
          <TextCopyright />
        </>
      )}
    </>
  );
};
export default PanelAnalysis;
